import React from 'react'
import { Typography, Grid, Container, useMediaQuery } from '@material-ui/core';
import { ReactComponent as SkywatchLogo } from '../../assets/skywatch-logo.svg';
import GlobalLogo from '../../assets/global-aviation-logo.png'
import './EndOfFlowPage.scss'
import { useLocation } from 'react-router-dom'
import Congratulations from './EndOfFlowPages/Congratulations'
import Declined from './EndOfFlowPages/Declined'
import UnderwritterRefferal from './EndOfFlowPages/UnderwritterRefferal'
import SaveRenewalChanges from './EndOfFlowPages/SaveRenewalChanges'
import NotCleared from './EndOfFlowPages/NotCleared'
import FaliurePage from './EndOfFlowPages/FaliurePage'

const EndOfFlowPage = () => {
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const location = useLocation()
    return (
        <div className='congrats-bg-img'>
            <Container style={{height: "100%"}}>

            <Grid container style={{height: "100%"}} direction="column" justifyContent={!isMobile ? 'center': 'none'}>
                {location.pathname.includes('congratulations') && 
                <Congratulations/>}
                {location.pathname.includes('savechangesrenewal') && 
                <SaveRenewalChanges/>}
                {location.pathname.includes('underwritterrefferal') && 
                <UnderwritterRefferal/>}
                {location.pathname.includes('notcleared') && 
                <NotCleared/>}
                {location.pathname.includes('declined') && 
                <Declined/>}
                {location.pathname.includes('wearealmostthere') && 
                <FaliurePage/>}
                        <Grid alignItems='center' container style={{width: '300px'}}> 
                            <Grid item xs={12} className="margin-bottom-6">
                                <Typography variant='body1' className='white'>Thank you for considering us</Typography>
                            </Grid>
                            <SkywatchLogo height={'20px'} className="margin-right-6"/>                            
                        </Grid>
                <Grid container>
                    <Grid item xs={12}>

                    </Grid>
                </Grid>
            </Grid>
            </Container>
        </div>
    )

}

export default EndOfFlowPage